module.exports = __webpack_public_path__ + "static/img/fangZhi.51ad89b1.jpg";